'use strict';

module.exports = {
    MEGABITS_PER_SECOND: 'Mbps',
    GIGABITS_PER_SECOND: 'Gbps'
};